import { render, staticRenderFns } from "./identificationCondition.vue?vue&type=template&id=2b51345f&scoped=true"
import script from "./identificationCondition.vue?vue&type=script&lang=js"
export * from "./identificationCondition.vue?vue&type=script&lang=js"
import style0 from "./identificationCondition.vue?vue&type=style&index=0&id=2b51345f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b51345f",
  null
  
)

export default component.exports